import { render, staticRenderFns } from "./SkillLevelChart.vue?vue&type=template&id=5f074208"
import script from "./SkillLevelChart.vue?vue&type=script&lang=ts"
export * from "./SkillLevelChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports